
export interface Apr {
    id: string;
    wellStringId: string;
    wellLongName: string;
    fieldLongName: string;
    platformLongName: string;
    stringShortName: string;
    stringLongName: string;
    wellProductionStatus: string;
    latestAprDate: string;
    aprDueDate: string;
    aprAdditionalDueDate: string;
    planDate: string;
    daysOverdue: number;
    daysSinceLastApr: number;
    installationStatus: string;
    remark: string;
    inputDate: string;
}